/*
 * File: CustomAlertContain.tsx
 * Project: a-a
 * File Created: Friday, 20th December 2024 7:59:11 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 16th September 2025 9:14:14 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import zeplinColor from '../../../theme/Color';

const CustomAlertContain = ({
  alertIcon,
  alert,
  error = false,
}: {
  alert?: string;
  alertIcon?: ReactNode;
  error?: boolean;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        padding: 0,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // backgroundColor: !error ? zeplinColor.Success : '',
          borderRadius: '60px',
          padding: '3px',
        }}
      >
        {alertIcon ? alertIcon : ''}
      </div>
      <Typography
        variant='body2'
        style={{ color: error ? zeplinColor.Neutral1 : zeplinColor.Neutral1 }}
      >
        {alert}
      </Typography>
    </div>
  );
};

export default CustomAlertContain;
